
<modal :state="state" :index="index" @toggle-modal="cancel">
  <div slot="body">
    <h3 class="modal-title">Custom Confirmation</h3>
    <div class="form-style">
      <row>
        <column class="row-title" size="100">
          <label for="header-field" class="v-label">Header:</label>
        </column>
        <column>
          <input type="text" id="header-field" placeholder="Type something" v-model="confirmation.header" @input="confirmationChanged">
        </column>
      </row>
      <row>
        <column>
          <label for="body-field">Body:</label>
          <wysiwyg
            id="body-field"
            name="body-field"
            v-model="confirmation.body"
            placeholder="Type your message here"
            :config-options="bodyWysiwygConfigOptions"
            :dynamic-options="bodyDynamicOptions"
            @input="confirmationChanged"
          ></wysiwyg>
        </column>
      </row>
    </div>

    <div class="cta">
      <button class="btn red outline block" @click="cancel">Cancel</button>
      <button class="btn green block" :disabled="!isComplete" @click="save">Save</button>
    </div>
  </div>
</modal>
